import script from "./ContestWinners.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestWinners.vue?vue&type=script&setup=true&lang=js"

import "./ContestWinners.vue?vue&type=style&index=0&id=365a473b&lang=scss"

const __exports__ = script;

export default __exports__